module.exports = __webpack_public_path__ + "img/m_ali.3d529b11.png";